<div class="proposal">

  @if (data?.IsTestMode) {
  <div class="test-mark">TEST DATA — not for customers</div>
  }

  <!-- ============== Letterhead ============== -->
  <div class="header">
    <img src="/img/Parent@2x.png" class="header-image" alt="Royal New York">
    <div class="contact-info">
      <div class="co">Royal New York</div>
      <div>661 Hadley Rd.</div>
      <div>South Plainfield, NJ 07080</div>
      <div>Phone: (908) 756-6400</div>
    </div>
    <div class="title">
      <div class="t1">Purchase Proposal</div>
      <div class="t2">Coffee coverage to new crop</div>
    </div>
  </div>

  <!-- ============== Customer + basis ============== -->
  <div class="info">
    <div class="info-left">
      <div class="lbl">Prepared for</div>
      <div class="cust">{{ data?.CompanyName }}</div>
      <div class="muted">Customer # {{ data?.CompanyID }}</div>
    </div>
    <div class="info-right">
      <div class="row"><span>Date</span><b>{{ data?.PreparedDate | date:'MMMM d, y' }}</b></div>
      <div class="row"><span>Warehouse</span><b>{{ data?.WarehouseName || '—' }}</b></div>
      <div class="row">
        <span>Usage based on</span>
        <b>{{ data?.BurnRange }}-month average ({{ data?.BurnWindowStart | date:'MMM y' }} – {{ data?.BurnWindowEnd | date:'MMM y' }})</b>
      </div>
    </div>
  </div>

  <!-- ============== Totals ============== -->
  <div class="totals">
    <div class="tot"><span>Coffees reviewed</span><b>{{ Rows.length }}</b></div>
    <div class="tot"><span>Bags on reserve</span><b>{{ TotalOnReserve | number:'1.0-0' }}</b></div>
    <div class="tot tot-main"><span>Recommended booking</span><b>{{ TotalRecommended | number:'1.0-0' }} bags</b></div>
  </div>

  <!-- ============== Table ============== -->
  <table class="grid">
    <thead>
      <tr>
        <th class="c-name">Coffee</th>
        <th>Monthly<br>usage</th>
        <th>On<br>reserve</th>
        <th>At your<br>roastery</th>
        <th>New crop<br>arrival</th>
        <th>Needed to<br>new crop</th>
        <th class="c-rec">Recommend<br>booking</th>
        <th class="c-bar">Next {{ BarCount }} months</th>
        <th>Covered<br>until</th>
      </tr>
    </thead>
    <tbody>
      @for (sec of Sections; track sec.name) {
      <tr class="sec"><td colspan="9">{{ sec.name }}</td></tr>
      @for (r of sec.rows; track $index) {
      <tr class="row-main">
        <td class="c-name">
          <div class="nm">{{ r.Name }}</div>
          @if (r.ContractThru) { <div class="sub">reserve contract thru {{ r.ContractThru | date:'MMM d, y' }}</div> }
        </td>
        <td>{{ r.BurnUsed | number:'1.0-1' }}</td>
        <td>
          {{ r.OnReserve | number:'1.0-0' }}
          @if (r.OnReserve) { <div class="sub">{{ r.ReservedSpot | number:'1.0-0' }} spot · {{ r.ReservedForward | number:'1.0-0' }} fwd</div> }
        </td>
        <td>{{ r.Roastery ? (r.Roastery | number:'1.0-0') : '—' }}</td>
        <td class="c-date">{{ (r.NewCrop | date:'MMM d, y') ?? '—' }}</td>
        <td>{{ r.Needed | number:'1.0-0' }}</td>
        <td class="c-rec" [class.buy]="r.Recommended > 0">{{ r.Recommended | number:'1.0-0' }}</td>
        <td class="c-bar">
          <div class="bar">
            @for (b of r.Bars; track $index) {
            <span class="cell {{ barClass(b, r.BurnUsed) }}" [class.crop]="b.crop"></span>
            }
          </div>
        </td>
        <td>{{ r.DepletionLabel }}</td>
      </tr>
      @if (r.RecText || r.Short) {
      <tr class="row-note">
        <td colspan="9">
          {{ r.RecText }}
          @if (r.Short) { <span class="short">Limited availability — please contact your trader.</span> }
        </td>
      </tr>
      }
      }
      }
    </tbody>
  </table>

  <div class="legend">
    <span><i class="sw ok"></i>Covered</span>
    <span><i class="sw low"></i>Less than one month left</span>
    <span><i class="sw neg"></i>Not covered</span>
    <span><i class="sw crop"></i>New-crop month</span>
  </div>

  <!-- ============== Summary of bookings ============== -->
  @if (ToBook.length) {
  <div class="book">
    <div class="book-title">Recommended bookings</div>
    @for (r of ToBook; track $index) {
    <div class="book-row">
      <span>{{ r.Name }}</span>
      <b>{{ r.Recommended | number:'1.0-0' }} {{ r.Recommended === 1 ? 'bag' : 'bags' }}</b>
      <span class="muted">through end of {{ r.CoverThrough | date:'MMM y' }}</span>
    </div>
    }
  </div>
  } @else {
  <div class="book covered">Your reserves and roastery stock cover your usage to new crop for every coffee above.</div>
  }

  <div class="footer">
    Projections use your average monthly usage over the period shown, your current reserves with Royal New York and the
    bags you hold at your roastery. They are estimates, not a commitment; availability and prices are confirmed at booking.
    Please contact your trader to book or to change any of these numbers.
  </div>
</div>
